import React from 'react'
import create_store from './store'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './asset/index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { HashRouter } from 'react-router-dom'

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
    <Provider store={create_store()}>
      <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorker.register('~serviceWorker.js')